import { useEffect, useState } from "react";

// Returns `value` only after it has stopped changing for `delay` ms (used for search boxes)
export default function useDebounce(value, delay = 300) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), delay);
        return () => window.clearTimeout(timer);
    }, [value, delay]);
    return debounced;
}
